import { isCasperWalletMobileIOS } from '../../utils/user-agent';

export const csprLiveSocialChannels = (t) => {
  return [
    {
      label: t('Telegram'),
      key: 'telegram',
      urlUserId: 'CSPRhub',
    },
    {
      label: t('X'),
      key: 'twitter_x',
      urlUserId: '@csprlive',
    },
    {
      label: t('Medium'),
      key: 'medium',
      urlUserId: 'csprsuite',
    },
  ];
};

export const makeSocialChannels = (t) => {
  return [
    {
      label: t('website'),
      key: 'website',
      urlUserId: 'https://makegroup.io/',
    },
    {
      label: t('LinkedIn'),
      key: 'linkedin',
      urlUserId: 'WeAreTeamMAKE',
    },
    {
      label: t('X'),
      key: 'twitter_x',
      urlUserId: '@WeAreTeamMAKE',
    },
  ];
};

export const csprSuiteSocialChannels = (t) => {
  return [
    {
      label: t('Developer Hub'),
      key: 'Developer Hub',
      url: 'https://cspr.build/',
    },
  ];
};

export const aboutCSPRLive = (t) => {
  return [
    {
      label: t('Documentation'),
      url: 'https://docs.casper.network/',
    },
    {
      label: t('License'),
      url: 'https://raw.githubusercontent.com/make-software/casper-clarity/master/LICENSE',
    },
    {
      label: t('Changelog'),
      url: '/changelog',
      target: '_top',
    },
    {
      label: t('Credits'),
      url: '/credits',
      target: '_top',
    },
    {
      label: t('Advertise with us'),
      url: '/advertise-with-us',
      target: '_top',
    },
    {
      label: t('24/7 support'),
      url: 'https://t.me/CSPRhub',
    },
  ];
};

export const aboutMake = (t) => {
  return [
    {
      label: t('Stake with us'),
      url: 'https://makestake.io/',
    },
    {
      label: t('Github'),
      url: 'https://github.com/make-software/',
    },
    {
      label: t('Contact Us'),
      url: 'https://makegroup.io/contact-us/',
    },
    {
      label: t('Give feedback / request feature'),
      url: 'https://feedback.cspr.live/',
    },
  ];
};

export const aboutCSPRSuite = (t) => {
  return [
    {
      label: t('CSPR.trade'),
      url: 'https://cspr.trade/',
    },
    {
      label: t('CSPR.click'),
      url: 'https://cspr.click/',
    },
    {
      label: t('CSPR.market'),
      url: 'https://cspr.market/',
    },
    {
      label: t('CSPR.studio'),
      url: 'https://cspr.studio/',
    },
    {
      label: t('CSPR.cloud'),
      url: 'https://cspr.cloud/',
    },
    {
      label: t('CSPR.name'),
      url: 'https://cspr.name/',
    },
    {
      label: t('Casper Wallet'),
      url: 'https://casperwallet.io',
    },
  ].filter(
    (item) => !(isCasperWalletMobileIOS() && item.url.includes('cspr.trade'))
  );
};

export const tosLinks = (t) => {
  return [
    {
      label: t('Privacy Policy'),
      url: '/privacy',
      target: '_top',
    },
    {
      label: t('Terms of Service'),
      url: '/tos',
      target: '_top',
    },
  ];
};
